<form
  #bookingQuestionForm="ngForm"
  #bookingQuestion
  role="form"
  [attr.aria-label]="'Booking questions form'"
  [attr.aria-live]="'polite'"
>
  <ng-template #recursiveListTmpl let-customFieldDependencies="customFieldDependencies">
    @for (dependencyCustomField of customFieldDependencies; track dependencyCustomField) {
      <div role="group" [attr.aria-label]="'Question group'">
        <app-booking-question
          [customField]="dependencyCustomField"
          [selectedCustomFieldValues]="bookingService?.selectedBookingData?.selectedCustomFieldValues"
          (radioButtonChangeEvent)="onRadioButtonChangeEvent($event)"
          [isNextButtonPressed]="isNextButtonPressed"
          (changeCustomFieldSelectedValueEvent)="customFieldChangeDetection($event)"
          (workerSelectAnswerInvalidated)="onWorkerSelectAnswerInvalidated($event)"
          role="group"
          [attr.aria-label]="(dependencyCustomField | translation: 'name': lang) + ' question'"
        />
        @if (dependencyCustomField?.customFieldDependencies?.length > 0) {
          <div role="group" [attr.aria-label]="'Dependent questions'" [attr.data-cbsw-dependencies-of]="widgetService.isWebComponentMode ? dependencyCustomField?.id : null">
            <ng-container *ngTemplateOutlet="recursiveListTmpl; context:{ customFieldDependencies: dependencyCustomField?.customFieldDependencies }" />
          </div>
        }
      </div>
    }
  </ng-template>

  <div role="group" [attr.aria-label]="'Main question'">
    <app-booking-question
      [customField]="widgetQuestion"
      [selectedCustomFieldValues]="bookingService?.selectedBookingData?.selectedCustomFieldValues"
      [isNextButtonPressed]="isNextButtonPressed"
      (radioButtonChangeEvent)="onRadioButtonChangeEvent($event)"
      (changeCustomFieldSelectedValueEvent)="customFieldChangeDetection($event)"
      (workerSelectAnswerInvalidated)="onWorkerSelectAnswerInvalidated($event)"
      role="group"
      [attr.aria-label]="(widgetQuestion | translation: 'name': lang) + ' question'"
    />
  </div>

  @if (widgetQuestion?.customFieldDependencies?.length > 0) {
    <div role="group" [attr.aria-label]="'Dependent questions'" [attr.data-cbsw-dependencies-of]="widgetService.isWebComponentMode ? widgetQuestion?.id : null">
      <ng-container *ngTemplateOutlet="recursiveListTmpl; context:{ customFieldDependencies: widgetQuestion?.customFieldDependencies }" />
    </div>
  }

  @if (showDependenciesGhostElement) {
    <div
      class="skeleton-box-card mt-4"
      role="status"
      [attr.aria-label]="'Loading questions'"
      [attr.aria-busy]="true"
    >
      <div class="row" role="list" [attr.aria-label]="'Loading question placeholders'">
        @for (dependenciesGhostElement of dependenciesGhostElements; track $index) {
          <div class="col-md-12" role="listitem">
            <div
              class="d-flex stats-card shadow"
              role="presentation"
              [attr.aria-hidden]="true"
            >
              <div class="skeleton-animation w-100 d-flex justify-content-center flex-column gap-3">
                <div class="bar bar-1"></div>
                <div class="bar bar-2"></div>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  } @else {
    <div
      class="d-flex justify-content-end mt-4 cbw-custom-navigation"
      role="navigation"
      [attr.aria-label]="'Question navigation'"
    >
      @if (widgetQuestion?.is_end_of_process !== 1 && !isEndOfProcessByChildDependencies) {
        <div class="me-2">
          <app-button
            id="{{ 'booking-questions-previous-btn' }}"
            [isDisabled]="isFirst && isBeforeQuestionsStep"
            (clickEvent)="previousQuestion()"
            [fontColor]="widgetService?.widgetConf?.button_font_color"
            [backgroundColor]="widgetService?.widgetConf?.button_background_color"
            role="button"
            [attr.aria-label]="'Go to previous question'"
            [attr.aria-disabled]="isFirst && isBeforeQuestionsStep"
            tabindex="0"
          >
            <span class="custom-button-icon back" aria-hidden="true"></span>
            {{ ((bookingService.widgetTemplates | calioMeetingTemplate: { id: templateConstant.WIDGET_PREVIOUS_BUTTON, type: 'template' }) | translation: 'template_content': lang )}}
          </app-button>
        </div>
        <div>
          @if (!isLast) {
            <app-button
              id="{{ 'booking-questions-next-question-btn' }}"
              (clickEvent)="nextQuestion()"
              [fontColor]="widgetService?.widgetConf?.button_font_color"
              [backgroundColor]="widgetService?.widgetConf?.button_background_color"
              role="button"
              [attr.aria-label]="'Go to next question'"
              tabindex="0"
            >
              {{ ((bookingService.widgetTemplates | calioMeetingTemplate: { id: templateConstant.WIDGET_NEXT_BUTTON, type: 'template' }) | translation: 'template_content': lang )}}
              <span class="custom-button-icon next" aria-hidden="true"></span>
            </app-button>
          }
          @if (isLast) {
            <app-button
              id="{{ 'booking-questions-finish-last-btn' }}"
              (clickEvent)="finishLastBookingQuestion()"
              [fontColor]="widgetService?.widgetConf?.button_font_color"
              [backgroundColor]="widgetService?.widgetConf?.button_background_color"
              role="button"
              [attr.aria-label]="'Finish questions and proceed'"
              tabindex="0"
            >
              {{ ((bookingService.widgetTemplates | calioMeetingTemplate: { id: templateConstant.WIDGET_NEXT_BUTTON, type: 'template' }) | translation: 'template_content': lang )}}
              <span class="custom-button-icon next" aria-hidden="true"></span>
            </app-button>
          }
        </div>
      }
    </div>
  }
</form>
